export const ButtonSize = {
    Small: 'sm',
    Large: 'lg',
    Default: ''
};
export const ButtonType = {
    Submit: 'submit',
    Button: 'button',
    Reset: 'reset'
};
export const ButtonVariant = {
    Primary: 'primary',
    Secondary: 'secondary',
    Tertiary: 'tertiary',
    Link: 'link',
    LinkSimple: 'link simple',
    Unstyled: 'unstyled'
};
